export { getOptimalTextShade } from './colors';
